import AdvantagesList from './advantagesList';

import { AccServiceBlock, AccServiceTitle, ServiceBlock, ServiceTitle } from '~/src/components/TariffCard/styled';

interface IInternetProps {
    isAccordion: boolean,
    withBg: boolean,
    bgColor: string,
    colorText: string,
    isOpen?: boolean,
    onToggle?: () => void,
    speed: number,
    advantages: string[],
}

const InternetBlock = ({ isAccordion, withBg, bgColor, colorText, isOpen, onToggle, speed, advantages }: IInternetProps): JSX.Element => {
    return (isAccordion && advantages.length
        ? <AccServiceBlock
            withBg={withBg}
            bgColor={bgColor}
            isClosed={!isOpen}
            defaultOpen={isOpen}
            open={isOpen}
            toggle={onToggle}
            data-test='options'
            title={
                <AccServiceTitle data-test='block-title'>
                    {speed}&nbsp;Мбит/с
                </AccServiceTitle>
            }
        >
            <AdvantagesList advantages={advantages}/>
        </AccServiceBlock>
        : <ServiceBlock>
            <ServiceTitle bgColor={bgColor} colorText={colorText} withBg={withBg} data-test='block-title'>
                {speed}&nbsp;Мбит/с
            </ServiceTitle>
            {!!advantages.length && <AdvantagesList advantages={advantages} data-test='advantages'/>}
        </ServiceBlock>
    );
};

export default InternetBlock;
